import { render } from "./BalancoEstoqueItens.vue?vue&type=template&id=e5d38db4&scoped=true&ts=true"
import script from "./BalancoEstoqueItens.vue?vue&type=script&lang=ts"
export * from "./BalancoEstoqueItens.vue?vue&type=script&lang=ts"

import "./BalancoEstoqueItens.vue?vue&type=style&index=0&id=e5d38db4&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5d38db4"]])

export default __exports__